import getPages from './getPages'
import { arrayToObject, isEmptyObject } from './utils'

export default function getAccount(state, ownProps) {
    const { config = {}, locale, pages = [], storeCredit = {}, country = {}, router = {} } = state
    const { location } = router
    const { titles } = config

    return {
        location,
        locale,
        pages: arrayToObject(pages, 'id'),
        titles,
        links: getPages(state, ownProps),
        storeCredit: !isEmptyObject(storeCredit),
        country
    }
}
